import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { CellType, CellRange, FlexGrid } from '@grapecity/wijmo.grid';
import { FlexGridFilter } from '@grapecity/wijmo.grid.filter';
import { Menu } from '@grapecity/wijmo.input';

import { PlessViewHelperSub } from "src/app/commons/kymw00/pless-view-helper-sub";
import { KYMW7100Model } from "./kymw7100.model";
import { KYMW00Model } from "src/app/commons/kymw00/kymw00.model";
import { GetBundleCatalogMediumService } from "./api-services/get-bundle-catalog-medium.service";
import { RegistBundleCatalogRoundInfoService } from "./api-services/regist-bundle-catalog-round-info.service";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { GetBundleCatalogRoundInfoService } from "./api-services/get-bundle-catalog-round-info.service";
import { PlessViewUtilsSub } from "src/app/commons/kymw00/pless-view-utils-sub.service";
import { BundleCatalogModel } from "./vo/bundle-catalog.model";
import { PlessAlert } from "src/app/shared/pless-alert/pless-alert.component";
import { DeleteBundleCatalogRoundInfoService } from "./api-services/delete-bundle-catalog-round-info.service";

interface Validation {
  validate: () => boolean;
  code: string,
  message: string[];
}

@Component({
  selector: 'app-kymw7100',
  templateUrl: 'kymw7100.component.html',
  styleUrls: ['kymw7100.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW7100Component extends PlessViewHelperSub implements OnInit, AfterViewInit {
  public kymw7100Model = new KYMW7100Model();
  private contextMenu: Menu;

  @ViewChild('dtg_BundleCatalogList', { static: true }) dtg_BundleCatalogList: FlexGrid;
  @ViewChild('fltr_BundleCatalogList', { static: true }) fltr_BundleCatalogList: FlexGridFilter;

  constructor(
    private elementRef: ElementRef,
    protected kymw00Model: KYMW00Model,
    private dialogService: PlessDialogServiceSub,
    private getBundleCatalogMediumService: GetBundleCatalogMediumService,
    private getBundleCatalogRoundInfoService: GetBundleCatalogRoundInfoService,
    private registBundleCatalogRoundInfoService: RegistBundleCatalogRoundInfoService,
    private deleteBundleCatalogRoundInfoService: DeleteBundleCatalogRoundInfoService
  ) {
    super(kymw00Model);
  }

  ngOnInit() {
    this.componentName = 'KYMW7100';
    this.kymw7100Model.kymw7100Component = this;
    this.getBundleCatalogMediumService.execute(this.kymw7100Model);
    this.getBundleCatalogRoundInfoService.execute(this.kymw7100Model);

    this.dtg_BundleCatalogList.itemsSourceChanged.addHandler(() => {
      this.dtg_BundleCatalogList.select(-1, -1);
      this.setRowBackgroundColor();
    });
    this.setContextMenu();
  }

  ngAfterViewInit() {
    this.dtg_BundleCatalogList.onSortedColumn = () => {
      this.setRowBackgroundColor();
    }
    this.fltr_BundleCatalogList.filterColumns = ['mediumTypeName'];
    this.fltr_BundleCatalogList.onFilterApplied = () => {
      this.setRowBackgroundColor();
    }
  }

  setRowBackgroundColor() {
    this.dtg_BundleCatalogList.rows.forEach(r => {
      if (r.dataItem.endDelivCatalogEndDate < this.getToday()) {
        r.cssClass = 'end-of-use';
      }
    });
  }

  private getToday() {
    const today = new Date();
    const year = today.getFullYear().toString();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const date = (today.getDate()).toString().padStart(2, '0');
    return `${year}${month}${date}`;
  }

  private setContextMenu() {
    this.createContextMenu();
    this.dtg_BundleCatalogList.hostElement.addEventListener('contextmenu', (e: MouseEvent) => {
      e.preventDefault();
      if (!this.contextMenu) {
        return;
      }
      const ht = this.dtg_BundleCatalogList.hitTest(e);
      if (ht.cellType === CellType.Cell) {
        const grid = new CellRange(ht.row, ht.col);
        this.dtg_BundleCatalogList.select(grid, false);
        this.contextMenu.show(e);
      }
    });
  }

  private createContextMenu() {
    this.contextMenu = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          {
            header: '削除',
            caption: '削除',
            cmd: 'delete',
            enabled: true
          },
        ],
        itemClicked: () => {
          if (this.contextMenu.selectedValue === 'delete') {
            this.eventDelete_CLICKHandler();
          }
        },
        command: {
          canExecuteCommand: (params) => {
            switch (params.cmd) {
              case 'delete':
                return this.isPermittedFullControl;
            }
          }
        }
      }
    );
  }

  private eventDelete_CLICKHandler() {
    const selectedItems = this.dtg_BundleCatalogList.selectedItems as BundleCatalogModel[];
    if (PlessViewUtilsSub.isEmptyArray(selectedItems)) {
      return;
    }
    this.dialogService.openAlertGetMessage('Q0176', [selectedItems[0].bundleCatalogName], this.eventConfirm_CLICKHandler(selectedItems[0]));
  }

  private eventConfirm_CLICKHandler(selectedItem: BundleCatalogModel) {
    return (closeAction: number) => {
      if (closeAction === PlessAlert.Yes) {
        this.kymw7100Model.deletedBundleCatalog = selectedItem;
        this.deleteBundleCatalogRoundInfoService.execute(this.kymw7100Model);
      }
    };
  }

  eventRegister_CLICKHandler() {
    const error = this.validate();
    if (error) {
      this.dialogService.openAlertGetMessage(error.code, error.message);
      return;
    }
    this.dialogService.openAlertGetMessage(
      'Q0104', ['束ね企画回'],
      (closeDetail) => {
        if (closeDetail === PlessAlert.Yes) {
          this.registBundleCatalogRoundInfoService.execute(this.kymw7100Model);
        }
      }
    );
  }

  private validations: Validation[] = [
    {
      validate: () => !PlessViewUtilsSub.isEmpty(this.kymw7100Model.formData.mediumType),
      code: 'E0103',
      message: ['媒体']
    },
    {
      validate: () => !PlessViewUtilsSub.isEmpty(this.kymw7100Model.formData.startOrderCode),
      code: 'W0001',
      message: ['開始受注コード']
    },
    {
      validate: () => !PlessViewUtilsSub.isEmpty(this.kymw7100Model.formData.endOrderCode),
      code: 'W0001',
      message: ['終了受注コード']
    },
    {
      validate: () => this.kymw7100Model.formData.startOrderCode <= this.kymw7100Model.formData.endOrderCode,
      code: 'E0123',
      message: ['受注コード']
    },
    {
      validate: () => !PlessViewUtilsSub.isEmpty(this.kymw7100Model.formData.startCatalogId),
      code: 'W0001',
      message: ['開始企画回']
    },
    {
      validate: () => !PlessViewUtilsSub.isEmpty(this.kymw7100Model.formData.endCatalogId),
      code: 'W0001',
      message: ['終了企画回']
    },
    {
      validate: () => !this.existsBundleCatalog(),
      code: 'E0250',
      message: ['設定されていない企画回']
    },
    {
      validate: () => !PlessViewUtilsSub.isEmpty(this.kymw7100Model.formData.bundleCatalogName),
      code: 'W0001',
      message: ['企画回名称']
    }
  ];

  /**
   * 
   * 仕様: 同一媒体で同一期間の束ね企画回は作成できない。
   * 
   */
  private existsBundleCatalog() {
    const duplicatedBundleCatalog = this.kymw7100Model.bundleCatalogList
      .filter(bc => bc.mediumType === this.kymw7100Model.formData.mediumType)
      .filter(bc => bc.startOrderCode <= this.kymw7100Model.formData.endOrderCode && bc.endOrderCode >= this.kymw7100Model.formData.startOrderCode);
    return duplicatedBundleCatalog.length > 0;
  }

  validate() {
    const error = this.validations.find(v => !v.validate());
    if (!error) {
      return null;
    }
    return { code: error.code, message: error.message };
  }
}